
// const hideValues = false

import ApiService from './ApiService'

class ConnectionService {
  getConnection = async () => {
    try {
      var connection = await ApiService.get(null, '/api/ping')
    } catch (err) {
      console.error(err)
    }
    return connection
  }
}
export default new ConnectionService()
